



































































import { Component, Vue } from 'vue-property-decorator';
import { WxClock, WxConfirm } from 'wax-lib';

@Component({ components: { wxClock: WxClock, itkErrorModal: WxConfirm } })
export default class User extends Vue {
    private clientcode = this.$store.getters.clientcode;
    private username = '';
    private password = '';
    private valid = false;

    private get form(): any {
        return this.$refs.form as any;
    }

    private async submit() {
        if (!this.form.validate()) return;

        const res = await this.$store.dispatch('loginUser', {
            clientcode: this.clientcode,
            username: this.username,
            password: this.password,
        });

        if (res.data) {
            await this.$router.push('/profile');
        }
    }
}
